export default "__VITE_ASSET__D$deBMmk__"